import {createSlice, PayloadAction} from '@reduxjs/toolkit'

interface Session {
  sessionId: string | null
}

const initialState: Session = {
  sessionId: null
}

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSessionId(state, action: PayloadAction<string>) {
      state.sessionId = action.payload
    },
    clearSessionId(state) {
      state.sessionId = null
    }
  }
})

export const {setSessionId, clearSessionId} = sessionSlice.actions

export const selectSessionId = (state: {session: Session}) =>
  state.session.sessionId

export default sessionSlice.reducer
